const defaultState = {};

const reducer = (state = defaultState, { type, data }) => {
  switch (type) {
    case 'set_lo_data':
      return {
        ...state,
        ...data,
      };
    case 'set_lo_service_access':
      return {
        ...state,
        serviceAccess: data,
      };
    default:
      return state;
  }
};

export default reducer;
